import { m } from '@pricedrop/i18n';
import { itemsHref } from '@/routes/items/-search-params';

export interface FeaturedCategory {
  tagId: number;
  label: () => string;
  iconName: string;
}

export const FEATURED_CATEGORIES: FeaturedCategory[] = [
  { tagId: 573, label: () => m.home_category_phones(), iconName: 'Smartphone' },
  { tagId: 271, label: () => m.home_category_laptops(), iconName: 'Laptop' },
  { tagId: 3156, label: () => m.home_category_tvs(), iconName: 'Tv' },
  { tagId: 242, label: () => m.home_category_headphones(), iconName: 'Headphones' },
  { tagId: 1304, label: () => m.home_category_gaming(), iconName: 'Gamepad2' },
  { tagId: 230, label: () => m.home_category_monitors(), iconName: 'Monitor' },
  { tagId: 218, label: () => m.home_category_keyboards(), iconName: 'Keyboard' },
  { tagId: 25005, label: () => m.home_category_vacuums(), iconName: 'Zap' },
  { tagId: 270, label: () => m.home_category_tablets(), iconName: 'Tablet' },
  { tagId: 2085, label: () => m.home_category_smartwatches(), iconName: 'Watch' },
  { tagId: 64059, label: () => m.home_category_speakers(), iconName: 'Speaker' },
  { tagId: 3604, label: () => m.home_category_toys(), iconName: 'ToyBrick' },
  { tagId: 1694, label: () => m.home_category_home(), iconName: 'Home' },
  { tagId: 4544, label: () => m.home_category_beauty(), iconName: 'Sparkles' },
  { tagId: 61581, label: () => m.home_category_coffee(), iconName: 'Coffee' },
  { tagId: 222, label: () => m.home_category_printers(), iconName: 'Printer' },
  { tagId: 255, label: () => m.home_category_consoles(), iconName: 'Joystick' },
  { tagId: 9532, label: () => m.home_category_fridges(), iconName: 'Refrigerator' },
  { tagId: 11175, label: () => m.home_category_washers(), iconName: 'WashingMachine' },
  { tagId: 5352, label: () => m.home_category_ac(), iconName: 'AirVent' },
];

// First 8 categories are shown as featured sections below the hero
export const HERO_SECTION_CATEGORIES: FeaturedCategory[] = FEATURED_CATEGORIES.slice(0, 8);

/**
 * Returns the /items URL with the given tag ID applied as a filter.
 * Uses the existing itemsHref() utility for consistency with the rest of the app.
 */
export function itemsHrefForTag(tagId: number): string {
  return itemsHref({ filters: [tagId], lowestPricesOnly: true });
}
